export default {
  fontFamily: `-apple-system, ".SFNSText-Regular", "San Francisco", BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", "Lucida Grande", Arial, sans-serif`,

  headings: {
    h1: {
      fontSize: '30px',
      lineHeight: '42px',
      fontWeight: 'bold'
    },
    h2: {
      fontSize: '22px',
      lineHeight: '31px',
      fontWeight: 'semibold'
    },
    h3: {
      fontSize: '16px',
      lineHeight: '23px',
      fontWeight: 'semibold'
    }
  },

  body: {
    regular: {
      fontSize: '14px',
      lineHeight: '20px'
    },
    secondary: {
      fontSize: '13px',
      lineHeight: '18px'
    },
    label: {
      fontSize: '10px',
      lineHeight: '14px',
      fontWeight: 'semibold',
      letterSpacing: '0.2px'
    }
  },

  input: {
    text: {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: '500'
    },
    disabled: {
      fontWeight: 'normal'
    },
    label: {
      fontSize: '12px',
      lineHeight: '17px',
      fontWeight: 'normal'
    },
    error: {
      fontSize: '12px',
      lineHeight: '17px'
    },
    password: {
      letterSpacing: '1px'
    }
  }
};
